import { useEffect, ReactNode } from 'react'
import UserAddedSuccess from '../../assets/UserAddedSuccess'
import AlertIcon from '../../assets/SendIconRed'
export interface ToastData {
  id: string
  title: string
  message: string
  type: 'success' | 'error'|'alert'//added alert as per the figma the font for error was not red
  duration?: number
  icon?: ReactNode
}

interface ToastProps {
  toast: ToastData
  onDismiss: (id: string) => void
}

export function Toast({ toast, onDismiss }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss(toast.id)
    }, toast.duration || 5000)

    return () => clearTimeout(timer)
  }, [toast.id, toast.duration, onDismiss])
if (toast.type === 'alert') {
    return (
      <div 
        className="bg-white rounded-xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] border border-[#d0d5dd] p-4 w-[400px] animate-slide-in"
        style={{ pointerEvents: 'auto' }}
      >
        <div className="flex gap-4 items-start">
          <div className="shrink-0 size-6">
            {toast.icon || <AlertIcon/>}
          </div>
          <div className="flex-1 min-w-0">
            <div className="mb-1">
              <h3 className="font-['Inter'] text-[14px] font-semibold leading-[20px] text-[#101828]">
                {toast.title}
              </h3>
            </div>
            <div className="mb-3">
              <p className="font-['Inter'] text-[14px] font-normal leading-[20px] text-[#344054]">
                {toast.message}
              </p>
            </div>
            <div>
              <button
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  onDismiss(toast.id)
                }}
                className="font-['Inter'] text-[14px] font-semibold leading-[20px] text-[#475467] hover:text-[#344054] transition-colors cursor-pointer bg-transparent border-none p-1"
                type="button"
                style={{ 
                  zIndex: 10000, 
                  pointerEvents: 'auto',
                  position: 'relative',
                  minWidth: '60px',
                  minHeight: '24px'
                }}
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
  if (toast.type === 'error') {
    return (
      <div 
        className="bg-white rounded-xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] border border-[#d0d5dd] p-4 w-[400px] animate-slide-in"
        style={{ pointerEvents: 'auto' }}
      >
        <div className="flex flex-col gap-3">
          <div>
            <h3 className="font-['Inter'] text-[14px] font-semibold leading-[20px] text-red-600">
              {toast.title}
            </h3>
          </div>
          <div>
            <p className="font-['Inter'] text-[14px] font-normal leading-[20px] text-red-600">
              {toast.message}
            </p>
          </div>
          <div>
            <button
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onDismiss(toast.id)
              }}
              className="font-['Inter']  text-[14px] font-semibold leading-[20px] text-textColor hover:text-textColor transition-colors cursor-pointer bg-transparent border-none p-1 "
              type="button"
              style={{ 
                zIndex: 10000, 
                pointerEvents: 'auto',
                position: 'relative',
                minWidth: '60px',
                minHeight: '24px'
              }}
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div 
      className="bg-white rounded-xl shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] border border-[#d0d5dd] p-4 w-[400px] animate-slide-in"
      style={{ pointerEvents: 'auto' }}
    >
      <div className="flex gap-4 items-start">
        <div className="shrink-0 size-6">
          {toast.icon || <UserAddedSuccess />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="mb-1">
            <h3 className="font-['Inter'] text-[14px] font-semibold leading-[20px] text-[#101828]">
              {toast.title}
            </h3>
          </div>
          <div className="mb-3">
            <p className="font-['Inter'] text-[14px] font-normal leading-[20px] text-[#344054]">
              {toast.message}
            </p>
          </div>
          <div>
            <button
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onDismiss(toast.id)
              }}
              className="font-['Inter'] text-[14px] font-semibold leading-[20px] text-[#475467] hover:text-[#344054] transition-colors cursor-pointer bg-transparent border-none p-1"
              type="button"
              style={{ 
                zIndex: 10000, 
                pointerEvents: 'auto',
                position: 'relative',
                minWidth: '60px',
                minHeight: '24px'
              }}
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}